import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { DrawerState } from "./drawer";

@Injectable({
    providedIn: "root"
})
export class DrawerService {
    private drawers: { [key: string]: Subject<DrawerState> } = {};

    register(name: string): void {
        if (!this.drawers[name]) {
            this.drawers[name] = new Subject<DrawerState>();
        }
    }

    unregister(name: string): void {
        delete this.drawers[name];
    }

    show(name: string): void {
        if (this.drawers[name]) {
            this.drawers[name].next('in');
        } else {
            throw new Error(`Drawer with name "${name}" is not registered.`);
        }
    }

    hide(name: string): void {
        if (this.drawers[name]) {
            this.drawers[name].next('out');
        } else {
            throw new Error(`Drawer with name "${name}" is not registered.`);
        }
    }

    getDrawerState(name: string): Observable<DrawerState> {
        if (!this.drawers[name]) {
            throw new Error(`Drawer with name "${name}" is not registered.`);
        }

        return this.drawers[name].asObservable();
    }
}
